import { render, staticRenderFns } from "./SummaryPoints.vue?vue&type=template&id=cd01de38&scoped=true"
import script from "./SummaryPoints.vue?vue&type=script&lang=ts"
export * from "./SummaryPoints.vue?vue&type=script&lang=ts"
import style0 from "./SummaryPoints.vue?vue&type=style&index=0&id=cd01de38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd01de38",
  null
  
)

export default component.exports